import { medtechApiClient } from '.';
import { Company, CompanyModel } from './model/companySettings';

export const companyApi = {
  async fetchCompany(companyId: number): Promise<Company> {
    const { data } = await medtechApiClient.get(`/v2/${companyId}/company`);
    return CompanyModel.parse(data);
  },
};
